
import React from 'react';
import { Settings, Lightbulb, Clock } from "lucide-react";

const SettingsTab = () => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium flex items-center">
        <Settings className="mr-2 h-5 w-5" /> Game Settings
      </h3>
      <p>
        Customize your Bitcoin Mining Career Simulator experience with various settings.
        These can be accessed from the Settings button in the main interface.
      </p>
      
      <div className="border rounded-md p-4 bg-muted/20">
        <h4 className="font-medium mb-2">Available Settings</h4>
        <div className="space-y-3">
          <div className="border border-primary/20 rounded p-3">
            <h5 className="font-medium">Difficulty Setting</h5>
            <p className="text-sm">Adjusts the overall difficulty of challenges and decision outcomes</p>
            <div className="mt-2 grid grid-cols-4 gap-2 text-xs">
              <div className="p-1 border rounded text-center">Easy</div>
              <div className="p-1 border rounded text-center bg-primary/10 border-primary">Normal</div>
              <div className="p-1 border rounded text-center">Hard</div>
              <div className="p-1 border rounded text-center">Expert</div>
            </div>
            <p className="text-xs mt-2 text-muted-foreground">
              Higher difficulty means greater rewards but also higher risks
            </p>
          </div>
          
          <div className="border border-primary/20 rounded p-3">
            <h5 className="font-medium">Game Speed</h5>
            <p className="text-sm">Controls how many challenges appear per year</p>
            <div className="mt-2 grid grid-cols-4 gap-2 text-xs">
              <div className="p-1 border rounded text-center">0.5x</div>
              <div className="p-1 border rounded text-center bg-primary/10 border-primary">1x</div>
              <div className="p-1 border rounded text-center">1.5x</div>
              <div className="p-1 border rounded text-center">2x</div>
            </div>
            <p className="text-xs mt-2 text-muted-foreground">
              Higher speed means more challenges and faster progression
            </p>
          </div>
          
          <div className="border border-primary/20 rounded p-3">
            <h5 className="font-medium flex items-center">
              <Clock className="h-4 w-4 mr-2 text-primary" /> Year Duration
            </h5>
            <p className="text-sm">Sets how long each career year lasts in real-time</p>
            <div className="mt-2 grid grid-cols-3 gap-2 text-xs">
              <div className="p-1 border rounded text-center">1 min</div>
              <div className="p-1 border rounded text-center bg-primary/10 border-primary">3 mins</div>
              <div className="p-1 border rounded text-center">5 mins</div>
            </div>
            <p className="text-xs mt-2 text-muted-foreground">
              Longer years give you more time to make decisions during each year
            </p>
          </div>
          
          <div className="border border-primary/20 rounded p-3">
            <h5 className="font-medium">Additional Options</h5>
            <div className="mt-2 space-y-2 text-sm">
              <div className="flex justify-between items-center">
                <span>Tutorial Tips</span>
                <span className="text-xs text-muted-foreground">Show helpful tips during gameplay</span>
              </div>
              <div className="flex justify-between items-center">
                <span>Auto Save</span>
                <span className="text-xs text-muted-foreground">Automatically save your progress</span>
              </div>
              <div className="flex justify-between items-center">
                <span>Sound Effects</span>
                <span className="text-xs text-muted-foreground">Enable game sound effects</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="border-l-4 border-primary p-4 bg-primary/5">
        <h4 className="font-medium flex items-center">
          <Lightbulb className="mr-2 h-4 w-4 text-primary" /> Settings Impact
        </h4>
        <p className="text-sm">
          Your settings choices affect various aspects of gameplay:
        </p>
        <ul className="list-disc list-inside space-y-1 text-sm mt-2">
          <li><span className="font-medium">Difficulty</span>: Affects challenge outcomes, KPI targets, and promotion requirements</li>
          <li><span className="font-medium">Game Speed</span>: Determines challenge frequency and overall simulation pace</li>
          <li><span className="font-medium">Year Duration</span>: Controls how long each simulation year lasts in real-time</li>
          <li><span className="font-medium">Tutorial Tips</span>: Shows or hides contextual gameplay guidance</li>
          <li><span className="font-medium">Auto Save</span>: Automatically saves your progress after key decisions</li>
        </ul>
      </div>
    </div>
  );
};

export default SettingsTab;
